module.exports = __webpack_public_path__ + "img/negotiation_header.ab8940b6.png";